import React from "react";
import { injectIntl } from "react-intl";
import styled from "styled-components/native";
import { localize } from "cci-utility";
import Label from "./Label";
import Error from "./Error";
import Alarm from "./Alarm";
import { Container } from "../layout/common";

// Replaced fielStyle by these properties to keep the same here and SelectField.web
const InputWrapper = styled.View`
  border-top-width: ${props => props.theme.fieldBorderTopWidth || 0}px;
  border-right-width: ${props => props.theme.fieldBorderRightWidth || 0}px;
  border-bottom-width: ${props => props.theme.fieldBorderBottomWidth || 0}px;
  border-left-width: ${props => props.theme.fieldBorderLeftWidth || 0}px;
  border-color: ${props => props.fieldBorderColor || props.theme.fieldBorderColor || "transparent"};
  background-color: ${props =>
    props.backgroundColor || props.theme.fieldBackgroundColor || "transparent"};
  border-radius: ${props => props.theme.fieldBorderRadius || 0}px;
  ${props => (props.theme.fieldFlex || props.flex) && `flex: ${props.theme.fieldFlex || props.flex};`}
  ${props => props.theme.fieldStyle}
  flex-direction: row;
  align-items: stretch;
`;

const BaseField = props => {
  const { intl, labelProps } = props,
    // Process labels as a string (if specified as such) or a react-intl message (for translation).
    label = localize(intl, props.label),
    alarm = localize(intl, props.alarm),
    error = localize(intl, props.error),
    addedProps = props.flexDirection === 'row' ? { flex: 1 } : {};

  return (
    <Container
      margins={props.margins}
      flex={props.flex}
      width={props.width}
      flexDirection={props.flexDirection}
      alignItems={props.alignItems}
    >
      {/* Field Label */}
      {label && (
        <Label margins="0 5px 5px 0" numberOfLines={props.labelNumberofLines} {...labelProps}>
          {label}
        </Label>
      )}

      <InputWrapper
        backgroundColor={props.backgroundColor}
        fieldBorderColor={props.fieldBorderColor}
        {...addedProps}
      >
        {/* Any component that goes to the left of the field, which can be an icon or a button */}
        {props.leftComponent}

        {props.children}

        {/* Any component that goes to the right of the field, which can be an icon or a button */}
        {props.rightComponent}
      </InputWrapper>

      {/* Error Message */}
      {error && <Error>{error}</Error>}
      {/* Alarm Message */}
      {alarm && <Alarm>{alarm}</Alarm>}
    </Container>
  );
};

export default injectIntl(BaseField);
